import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EncodeHttpParamsInterceptorInterceptor } from './encode-http-params-interceptor.interceptor';
import { SharedModule } from './shared/shared.module';
import { BadeloftPagesModule } from './views/badeloft-pages/badeloft-pages.module';
import { LoginComponent } from './views/login/login.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    BadeloftPagesModule,
    HttpClientModule,
    NgxSpinnerModule
  ],
  providers: [  {
    provide: HTTP_INTERCEPTORS,
    useClass: EncodeHttpParamsInterceptorInterceptor,
    multi: true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
